import { render, staticRenderFns } from "./card-communication.vue?vue&type=template&id=095b705a&"
import script from "./card-communication.vue?vue&type=script&lang=js&"
export * from "./card-communication.vue?vue&type=script&lang=js&"
import style0 from "./card-communication.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports